<div class="modal-content">
  <div class="modal__content">
    <div class="modal__tabs">
      <div
        id="tabOne"
        [class]="individualCustomerBtnClass"
        (click)="selectTab(1)"
      >
        {{ 'sharedModule.bkgLoginDialog.individualCustomer' | translate }}
      </div>
      <div id="tabTwo" [class]="agencyBtnClass" (click)="selectTab(2)">
        {{ 'sharedModule.bkgLoginDialog.agencies' | translate }}
      </div>
    </div>

    <ng-container *ngIf="isIndividualCustomer">
      <div class="modal__header">
        <h3 class="h3 modal__title">
          {{ 'sharedModule.bkgLoginDialog.title' | translate }}
        </h3>
        <button
          *ngIf="!modifyToken"
          (click)="onContinue()"
          type="button"
          class="modal__close"
        >
          <img src="assets/images/icons/close.svg" />
        </button>
      </div>

      <div class="modal__body">
        <bkg-dialog-banner
          [isVisible]="!!errorMessage"
          [message]="errorMessage"
          (closeBanner)="onCloseBanner()"
        >
        </bkg-dialog-banner>

        <p>{{ 'sharedModule.bkgLoginDialog.bodyTitle' | translate }}</p>
        <div class="login">
          <div class="login__external">
            <button
              (click)="onClickFacebookLogin()"
              type="button"
              class="btn-facebook"
            >
              {{ 'sharedModule.bkgLoginDialog.facebookBtn' | translate }}
            </button>

            <button
              (click)="onClickGoogleLogin()"
              type="button"
              class="btn-google"
            >
              {{ 'sharedModule.bkgLoginDialog.googleBtn' | translate }}
            </button>

            <button
              *ngIf="isIos"
              (click)="onClickAppleLogin()"
              type="button"
              class="btn-apple"
            >
              {{ 'sharedModule.bkgLoginDialog.appleBtn' | translate }}
            </button>
          </div>

          <bkg-separator></bkg-separator>

          <form *ngIf="form" [formGroup]="form" id="loginForm" errorTailor>
            <!-- fake inputs for google autofill -->
            <input
              autocomplete="email"
              style="display: none"
              type="text"
              name="email"
            />
            <input
              autocomplete="current-password"
              style="display: none"
              type="password"
              name="fakepasswordremembered"
            />
            <!-- ------------ -->
            <div class="login__form-row">
              <div class="form-group" [class.success]="isValidField('email')">
                <label class="sr-only">
                  {{ 'sharedModule.bkgLoginDialog.email' | translate }}
                </label>
                <input
                  formControlName="email"
                  type="email"
                  id="login-email"
                  placeholder="{{
                    'sharedModule.bkgLoginDialog.email' | translate
                  }}"
                  [class.warning]="hasErrors('email')"
                  controlErrorsClass="info-field"
                />
              </div>

              <div
                class="form-group"
                [class.success]="isValidField('password')"
              >
                <label class="sr-only">
                  {{ 'sharedModule.bkgLoginDialog.password' | translate }}
                </label>
                <input
                  required
                  formControlName="password"
                  type="password"
                  id="login-password"
                  placeholder="{{
                    'sharedModule.bkgLoginDialog.password' | translate
                  }}"
                  [class.warning]="hasErrors('password')"
                  controlErrorsClass="info-field"
                />
              </div>
            </div>
            <a
              *ngIf="!modifyToken"
              (click)="navigateToForgetYourPass()"
              class="login__forgot-pw link"
            >
              {{ 'sharedModule.bkgLoginDialog.forgetPassword' | translate }}
            </a>

            <button
              (click)="onClickLoginBtn()"
              [class.disabled]="isInvalidForm"
              [class.space-top]="modifyToken"
              class="btn-primary btn-large is-block"
            >
              {{ 'sharedModule.bkgLoginDialog.loginBtn' | translate }}
            </button>

            <p *ngIf="!modifyToken" class="login__form-extra">
              {{ 'sharedModule.bkgLoginDialog.accountMessage' | translate }}
              <a (click)="navigateToSignUp()" class="link">
                {{ 'sharedModule.bkgLoginDialog.signUpFree' | translate }}
              </a>
            </p>
          </form>
        </div>
      </div>

      <div *ngIf="!modifyToken" class="modal__footer has-border">
        <a (click)="onContinue()" class="login__footer link">
          <span *ngIf="showContinue">
            {{ 'sharedModule.bkgLoginDialog.continueRegistration' | translate }}
          </span>
          <span *ngIf="!showContinue">
            {{ 'sharedModule.bkgSignUpDialog.cancel' | translate }}
          </span>
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="isAgency">
      <div class="modal__header">
        <h3 class="h3 modal__title">
          {{ 'sharedModule.bkgLoginDialog.agencyTitle' | translate }}
        </h3>
      </div>

      <div class="modal__body--agency">
        <bkg-dialog-banner
          [isVisible]="!!errorMessage"
          [message]="errorMessage"
          (closeBanner)="onCloseBanner()"
        >
        </bkg-dialog-banner>

        <form [formGroup]="form" errorTailor>
          <div class="login__form-row--agency">
            <div class="form-group" [class.success]="isValidField('alias')">
              <label class="sr-only">
                {{ 'sharedModule.bkgLoginDialog.alias' | translate }}
              </label>
              <input
                autocomplete="alias"
                formControlName="alias"
                id="login-alias"
                placeholder="{{
                  'sharedModule.bkgLoginDialog.alias' | translate
                }}"
                [class.warning]="hasErrors('alias')"
                controlErrorsClass="info-field"
              />
            </div>

            <div class="form-group" [class.success]="isValidField('password')">
              <label class="sr-only">
                {{ 'sharedModule.bkgLoginDialog.password' | translate }}
              </label>
              <input
                required
                formControlName="password"
                type="password"
                autocomplete="current-password"
                id="login-password"
                placeholder="{{
                  'sharedModule.bkgLoginDialog.password' | translate
                }}"
                [class.warning]="hasErrors('password')"
                controlErrorsClass="info-field"
              />
            </div>
          </div>
          <button
            (click)="onClickAgencyLoginBtn()"
            [class.disabled]="isInvalidForm"
            [class.space-top]="modifyToken"
            class="btn-primary btn-large is-block"
          >
            {{ 'sharedModule.bkgLoginDialog.loginBtn' | translate }}
          </button>
        </form>
      </div>

      <div *ngIf="!modifyToken" class="modal__footer has-border">
        <a (click)="onContinue()" class="login__footer link">
          <span *ngIf="showContinue">
            {{ 'sharedModule.bkgLoginDialog.continueRegistration' | translate }}
          </span>
          <span *ngIf="!showContinue">
            {{ 'sharedModule.bkgSignUpDialog.cancel' | translate }}
          </span>
        </a>
      </div>
    </ng-container>
  </div>
</div>
